import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export const PAGE_PARAM = "page";

export const usePageParam = (): number => {
  const [searchParams] = useSearchParams();

  const parsed = parseInt(searchParams.get(PAGE_PARAM) ?? "1", 10);
  const currentPage = Number.isNaN(parsed) || parsed < 1 ? 1 : parsed;

  const renderedPage = useRef(currentPage);
  useEffect(() => {
    if (renderedPage.current === currentPage) return;
    renderedPage.current = currentPage;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentPage]);

  return currentPage;
};
